import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalCheckbox,
  NormalInput,
  NormalTextarea,
} from "component/common";
import { withTranslation } from "react-i18next";
import { NewMyequipments, Myequipments } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";

export default class EquipmentdetailsClass extends Component {
  state = {
    code: null,
    desc: null,
    epuidesc: null,
    checked: true,
    List: [],
  };

  componentDidMount = () => {
    this.Listofequiments({});
  };

  Listofequiments = async () => {
    let { List, code } = this.state;
    await this.props.Myequipments().then((res) => {
      List = res;
      this.setState({
        List,
      });
      console.log(List.length);
    });
    if (List.length > 0) {
      code = List[List.length - 1].equipmentCode;
      console.log(code);
      code = code.slice(code.length - 5);
      code = Number(code) + 1;
      code = "EQU" + code;
    } else {
      code = "EQU" + 10001;
    }
    this.setState({
      code,
    });
  };

  temp = ({ target: { value, name } }) => {
    console.log(value, name);
    let { code, desc, epuidesc, checked } = this.state;
    if (name == "code") {
      code = value;
      this.setState({ code });
    }
    if (name == "desc") {
      desc = value;
      this.setState({ desc });
    }
    if (name == "epuidesc") {
      epuidesc = value;
      this.setState({ epuidesc });
    }
    if (name == "check") {
      checked = value;
      this.setState({ checked });
    }
  };

  Addnewequiment = async () => {
    let { code, desc, epuidesc, checked } = this.state;
    if (desc == null) {
      Toast({
        type: "error",
        message: "Description required",
      });
    } else {
      let newequiment = {
        equipmentCode: code,
        equipmentName: desc,
        equipmentDescription: epuidesc,
        equipmentIsactive: checked,
      };
      await this.props
        .NewMyequipments(newequiment)
        .then((data) => {
          Toast({
            type: "success",
            message: "Successfully Added",
          });
          this.props.history.push("/admin/backend/appointment/equipment")
          this.handleimput();
        })
        .catch((e) => console.log(e));
    }
  };
  handleimput = () => {
    let { code, desc, epuidesc, checked } = this.state;
    desc = "";
    epuidesc = "";
    checked = false;
    this.setState({ checked, desc, epuidesc });
    this.Listofequiments();
  };
  render() {
    let { t } = this.props;
    let { code, desc, epuidesc, checked } = this.state;
    return (
      <div className="bg-white">
        <div className="row">
          <div className="col-12 mt-4">
            <div className="col-12 detail d-md-flex align-items-center">
              <h6
                className="category mt-1"
                onClick={() => this.props.history.push("/admin/backend")}
              >
                {t("Master Data")}
              </h6>
              <i className="icon-right mx-md-3 p-1"></i>
              <h6
                className="sub-category mt-1"
                onClick={() => this.props.history.push("/admin/backend")}
              >
                {t("Appointment config")}
              </h6>
              <i className="icon-right mx-md-3 p-1"></i>
              <h6
                className="sub-category mt-1"
                onClick={() => this.props.history.push("/admin/backend")}
              >
                {t("Equipment")}
              </h6>
              <i className="icon-right mx-md-3 p-1"></i>
              <h6 className="sub-category mt-1">{t("Add")}</h6>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h5 className="mt-4 mb-0 label-head text-center text-md-left">
                Equipment
              </h5>
            </div>
          </div>
          <div className="col-12 col-md-6 mt-4">
            <h6>
              Equiptment ID<span style={{ color: "red" }}>*</span>
            </h6>
            <NormalInput
              value={code}
              name="code"
              onChange={this.temp}
              disabled={true}
            />
          </div>
          <div className="col-12 col-md-6 mt-4">
            <h6>
              Equipment Name<span style={{ color: "red" }}>*</span>
            </h6>
            <NormalInput value={desc} name="desc" onChange={this.temp} />
          </div>
          <div className="col-12 col-md-6 mt-4">
            <h6>Description</h6>
            <NormalTextarea
              placeholder="Enter Equipment Description"
              value={epuidesc}
              name="epuidesc"
              onChange={this.temp}
            />
          </div>
          <div className="col-12 col-md-6">
            <div className="d-flex mt-3">
              <NormalCheckbox
                checked={checked}
                name="check"
                onChange={this.temp}
              />
              <p>{t("Active")}</p>
            </div>
          </div>

          <div className="mt-3 col-12 col-md-2">
            <NormalButtonBackend
              mainbg={true}
              label={"Add"}
              onClick={() => this.Addnewequiment()}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      NewMyequipments,
      Myequipments,
    },
    dispatch
  );
};

export const Equipmentdetails = withTranslation()(
  connect(null, mapDispatchToProps)(EquipmentdetailsClass)
);
